// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"vendor":1,"react":1}[chunkId]) return "static/js/" + chunkId + ".js";
	// return url for filenames based on template
	return "static/js/" + {"src_apps_configurator_containers_Parts_index_jsx":"6b7eea62","src_Icons_shapes_custom_DK_svg":"a9c177f4","src_Icons_shapes_custom_NO_svg":"740ed043","src_Icons_shapes_custom_IT_svg":"dc61f811","src_Icons_shapes_custom_PL_svg":"63d6ba56","src_Icons_shapes_custom_PT_svg":"8be1320f","src_Icons_shapes_custom_SE_svg":"431d9ad8"}[chunkId] + ".chunk.js";
};